import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { achLocations } from './fixtures/ach-locations.fixture';
import { beneficialOwners } from './fixtures/beneficial-owners.fixture';
import { ACHTransactions } from './fixtures/ach-transactions.fixture';
import { ACHTransfersConfig } from './fixtures/ach-transfers-config.fixture';

const apiPrefix = `${getEnv(
  'REACT_APP_ADMIN_API_URL',
)}/incentivio-giftcard-ach-service`;

export const listAchLocationsMock = fn =>
  rest.get(`${apiPrefix}/achlocations`, fn);

export const getAchLocationMock = fn =>
  rest.get(`${apiPrefix}/achlocations/:locationId`, fn);

export const listBeneficialOwnersMock = fn =>
  rest.get(`${apiPrefix}/achlocations/:poolLocationId/beneficialowners`, fn);

export const listACHTransactionsMock = fn =>
  rest.get(`${apiPrefix}/achlocations/:locationId/transfers`, fn);

export const fetchClientTokenMock = fn =>
  rest.post(`${apiPrefix}/client-token`, fn);

export const removeACHLocationMock = fn =>
  rest.delete(`${apiPrefix}/achlocations/:locationId/customer`, fn);

export const removeFundingSourceMock = fn =>
  rest.delete(`${apiPrefix}/achlocations/:locationId/funding-source`, fn);

export const updateACHLocationsMock = fn =>
  rest.put(`${apiPrefix}/achlocations`, fn);

export const updateLocationsFundTransferConfigMock = fn =>
  rest.patch(`${apiPrefix}/fund-transfer-config/locations`, fn);

export const updatePoolLocationFundTransferConfigMock = fn =>
  rest.patch(`${apiPrefix}/fund-transfer-config/pool-account`, fn);

export const addFundingAccountMock = fn =>
  rest.put(`${apiPrefix}/achlocations/:locationId/fundingaccount`, fn);

export const verifyMicroDepositsMock = fn =>
  rest.post(
    `${apiPrefix}/achlocations/:locationId/fundingaccount/:fundingAccountId/verifymicrodeposits`,
    fn,
  );

export const copyACHLocationMock = fn =>
  rest.post(`${apiPrefix}/achlocations/copy-customer-and-account`, fn);

export const handlers = () => [
  listAchLocationsMock((_req, res, ctx) => res(ctx.json(achLocations))),
  getAchLocationMock((req, res, ctx) => {
    const location = achLocations.find(
      loc => loc.locationId === req.params.locationId,
    );
    if (!location) {
      return res(ctx.status(404));
    }
    return res(ctx.json(location));
  }),
  listBeneficialOwnersMock((_req, res, ctx) => res(ctx.json(beneficialOwners))),
  listACHTransactionsMock((_req, res, ctx) => res(ctx.json(ACHTransactions))),
  fetchClientTokenMock((_req, res, ctx) =>
    res(
      ctx.json({ token: 'GxA2zmsoJiwcNkvVx3DG2SDbtTNUkVe8oK7LTzXQnIPKVKceh1' }),
    ),
  ),
  removeFundingSourceMock((_req, res, _ctx) => res.status(200)),
  removeACHLocationMock((_req, res, _ctx) => res.status(200)),
  updateACHLocationsMock((_req, res, ctx) => res(ctx.status(200))),
  updateLocationsFundTransferConfigMock((_req, res, ctx) =>
    res(ctx.json(ACHTransfersConfig)),
  ),
  updatePoolLocationFundTransferConfigMock((_req, res, ctx) =>
    res(ctx.json(ACHTransfersConfig)),
  ),
  addFundingAccountMock((_req, res, ctx) => res(ctx.status(200))),
  copyACHLocationMock((_req, res, ctx) => res(ctx.status(200))),
  verifyMicroDepositsMock((_req, res, ctx) => res(ctx.status(200))),
];
